export default ({ internal_link_page, setPage, onClose, setInternalBackButton, ...props }) => {
  setPage(internal_link_page.id);
  setInternalBackButton();
  onClose();
  return null;
};